import { type ConfigurableView, type SortField, type ViewTypeName } from '@air/api/types';

export type GetSavedSortFieldFromViewsParams = {
  views: ConfigurableView[] | undefined;
  viewTypeName: ViewTypeName | undefined;
};

export const getSavedSortFieldFromViews = ({
  views,
  viewTypeName,
}: GetSavedSortFieldFromViewsParams): SortField | undefined => {
  if (!views?.length) {
    return undefined;
  }

  // Prefer the view matching viewTypeName so gallery vs table saved sorts stay independent.
  const matchingView = views.find((view) => view.viewType.name === viewTypeName);
  // Default view is the board's saved "open as" sort when this showcase is not showing that view type.
  const selectedView = matchingView ?? views.find((view) => view.isDefault);
  const savedSort = selectedView?.sortFields[0];

  if (!savedSort?.name) {
    return undefined;
  }

  return savedSort;
};
